export function fadeOutStep(step) {
    

    let positionLeft = step.offsetLeft;
    let positionTop = step.offsetTop;
    
    step.style.position = "fixed";
    step.style.width = '100%';
    step.style.left = positionLeft + 'px';
    step.style.top = positionTop + 'px';
    step.style['z-index'] = 1;

    fadeOutStepAnimation(step).restart();



}

export function directlyHideStep(step) {
    step.style.display = 'none';
}






function fadeOutStepAnimation(stepHolder) {
    let tl = new gsap.timeline({paused: true})

    tl.to(stepHolder, {
       scale: .7,
        alpha: .2, 
        duration: 1,
        filter:"blur(10px)"
    })
    tl.to(stepHolder, {
        x: '-80%',
        scale: 0,
        alpha: 0,
        duration: 1.5
    })

    return tl; 

}



export function fadeInStepAnimation(stepHolder) {
    let tl = new gsap.timeline({paused: true})
    tl.from(stepHolder, {
        x: '+10%',
        scale: .4,
        alpha: 0,
        duration: .7
    })

    return tl; 

}


export function highlightSelectedSelection(selection) {
    selection.classList.add("selected");
}